export default __webpack_public_path__ + "0a4bf5884909f36cebd8ca8044ebfd36.svg";